<template>
	<div class="school-input">
		<my-input
      :tipText="schoolTip"
      :text="school"
      :isError="isError"
      :maxLength="maxLength"
      @tipClick="schoolClick"
      @blurEvent="checkSchool">
    </my-input>
	</div>
</template>
<script>
import * as types from '../../../../store/mutation-types';
import config from '../../../../util/config';
import myInput from '../../../common/myInput';
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			isError: false,
			schoolTip: '学校名称',
			school: '',
			maxLength: 20,
			state: false // 填写状态
		};
	},
	created() {
		this.gradschool && this.checkSchool(this.gradschool); // 初始化编辑数据
	},
	watch: {
		gradschool(val) {
			this.school = val;
		},
		eduIndex(val) {
			this.gradschool && this.checkSchool(this.gradschool);
		}
	},
	methods: {
		schoolClick(value) {
			// 第一次点击
			if (value === '') {
				this.isError = false;
				this.schoolTip = '请输入学校名称4-20个汉字';
			}
		},
		checkSchool(value) {
			this.school = value;
			if (value === '') {
				this.isError = true;
				this.schoolTip = '学校名称';
				this.state = false;
			} else if (!config.schoolReg.test(value)) {
				this.isError = true;
				this.schoolTip = '只能填写4-20个汉字';
				this.state = false;
			} else {
				this.isError = false;
				this.schoolTip = '学校名称';
				this.state = true;
			}
			this.$store.commit(types.CHECK_EDUINFO, {
				key: 'gradschool',
				value: value,
				state: this.state
			});
		},
		// 点击保存检查为空
		checkNull() {
			this.checkSchool('');
		}
	},
	computed: mapGetters(['gradschool', 'eduIndex']),
	components: {
		myInput
	}
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/style/public.scss';
</style>



// WEBPACK FOOTER //
// gradSchool.vue?30a4a5f8